var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPointer = function SvgPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 230,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.326 45.761a.459.459 0 0 0 .037-.654l-2.788-3.079 3.122-2.74a.459.459 0 0 0 .037-.654.475.475 0 0 0-.664-.038l-3.473 3.048a.459.459 0 0 0-.037.654l3.101 3.425a.477.477 0 0 0 .665.038Z",
    fill: "#C5CBD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.621 221.561C87.341 217.349 108.646 44.516 7.969 41.991",
    stroke: "#C5CBD1",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })));
};
export default SvgPointer;